import * as yup from 'yup';

import { strings } from '../strings';

export enum ApprovePuzzleField {
  KEYWORDS = 'keywords',
  COLLECTION = 'collectionId',
  CALCULATED_ROYALTY = 'calculatedRoyalty',
}

export const approvePuzzleSchema = yup.object().shape({
  [ApprovePuzzleField.KEYWORDS]: yup.string().trim().required(strings.collectionKeywordsRequired),
  [ApprovePuzzleField.COLLECTION]: yup
    .object()
    .shape({ label: yup.string(), value: yup.string() })
    .nullable()
    .required(strings.collectionIsRequired),
});
